import { CheckCircle2, Clock, AlertTriangle, Circle, Wallet } from "lucide-react";

const STATUS_CONFIG = {
  paid: {
    label: "Pagado",
    border: "border-emerald-400/60",
    bg: "bg-emerald-400/10",
    text: "text-emerald-400",
    dot: "bg-emerald-400",
    Icon: CheckCircle2,
    pulse: false,
  },
  partial: {
    label: "Pago Parcial",
    border: "border-[#F59E0B]/60",
    bg: "bg-[#F59E0B]/10",
    text: "text-[#F59E0B]",
    dot: "bg-[#F59E0B]",
    Icon: Wallet,
    pulse: false,
  },
  pending: {
    label: "Pendiente",
    border: "border-[#A78BFA]/50",
    bg: "bg-[#A78BFA]/5",
    text: "text-[#A78BFA]",
    dot: "bg-[#A78BFA]",
    Icon: Clock,
    pulse: false,
  },
  overdue: {
    label: "Vencido",
    border: "border-[#EF4444]/60",
    bg: "bg-[#EF4444]/10",
    text: "text-[#EF4444]",
    dot: "bg-[#EF4444]",
    Icon: AlertTriangle,
    pulse: true,
  },
  empty: {
    label: "Sin facturas",
    border: "border-[#2E2E33]",
    bg: "bg-[#1A1A1F]",
    text: "text-[#71717A]",
    dot: "bg-[#71717A]",
    Icon: Circle,
    pulse: false,
  },
};

const formatMoney = (n) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n || 0);

/**
 * Traffic-light financial status badge for SGM groups.
 * Receives the `financial` object emitted by the backend:
 *   { invoiced, paid, balance, status, oldest_unpaid_days, invoices_count }
 */
export default function GroupStatusBadge({ financial, compact = false }) {
  if (!financial) return null;
  const cfg = STATUS_CONFIG[financial.status] || STATUS_CONFIG.empty;
  const { Icon } = cfg;
  return (
    <div
      className={`inline-flex items-center gap-2 border ${cfg.border} ${cfg.bg} ${cfg.text} px-2.5 py-1`}
      data-testid={`group-status-${financial.status}`}
      title={`Facturado ${formatMoney(financial.invoiced)} · Pagado ${formatMoney(financial.paid)} · Saldo ${formatMoney(financial.balance)}${financial.status === "overdue" ? ` · ${financial.oldest_unpaid_days} días vencido` : ""}`}
    >
      <span className={`relative w-2 h-2 rounded-full ${cfg.dot} ${cfg.pulse ? "animate-pulse" : ""}`}>
        {cfg.pulse && <span className={`absolute inset-0 rounded-full ${cfg.dot} opacity-60 animate-ping`}></span>}
      </span>
      <Icon className="w-3 h-3" />
      <span className="font-mono text-[10px] uppercase tracking-widest font-bold">{cfg.label}</span>
      {!compact && financial.invoices_count > 0 && (
        <span className="font-mono text-[10px] text-current/70 hidden sm:inline">
          · {formatMoney(financial.balance)}
        </span>
      )}
    </div>
  );
}
